import { memo } from "react";

import InvoiceDataSectionContainer from "./InvoiceDataSectionContainer";

export default memo(InvoiceDataSectionContainer);
